import { Button, makeStyles, Card, CardContent, Typography, Accordion, AccordionSummary, AccordionDetails} from "@material-ui/core";
import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { fadeInRight, fadeInLeft, fadeIn, fadeInUp } from 'react-animations';
import { StyleRoot, keyframes } from 'radium';
import "./Home.css";
import BasicModal from "../../components/Modal/BasicModal"
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import { useCookies } from 'react-cookie';

const Home = ({ fetchQuestions, setAnswers, openModal, handleOpenModal, handleCloseModal, removeLocalStorage, lng }) => {
  const [error, setError] = useState(false);
  const history = useHistory();
  const [cookies, setCookie] = useCookies(['affcode']);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
    setAnswers([]);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname});
    ReactPixel.pageView();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const affcodeFromURL = urlParams.get('affcode');

    if (affcodeFromURL) {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 30);
      
      setCookie('affcode', affcodeFromURL, { expires: expirationDate });
    }
  }, [setCookie]);


  const handleSubmit = async () => {
    handleCloseModal();
    const data = await fetchQuestions();

    if (Array.isArray(data)) {
      removeLocalStorage();

      let testRoute = lng !== "en" ? `/${lng}/testing/` : `/testing/`;
      history.push(testRoute);
    } else {
      window.scrollTo(0, 0)
      setError(true);
    }
  };

  const useStyles = makeStyles({
    button: {
      backgroundColor: "#F49F1C",
      borderRadius: "30px",
      fontSize: "20px",
      marginTop: "30px",
      padding: "20px 30px",
      '&:hover': {
        backgroundColor: '#030E4F',
        "& .MuiButton-label": {
          color: '#F49F1C'
        }
      }
    },
    button2: {
      backgroundColor: "#F49F1C",
      borderRadius: "30px",
      fontSize: "20px",
      padding: "20px 30px",
      '&:hover': {
        backgroundColor: '#030E4F',
        "& .MuiButton-label": {
          color: '#F49F1C'
        }
      }
    }
  })
  const classes = useStyles()


  const styles = {
    fadeInUp: {
      animation: 'x 0.5s',
      animationName: keyframes(fadeInUp, 'fadeInUp'),
      animationDelay: '0.3s',
      animationFillMode: 'forwards',
      opacity: 0
    },
    fadeInRight: {
      animation: 'x 0.8s',
      animationName: keyframes(fadeInRight, 'fadeInRight')
    },
    fadeInLeft1: {
      animation: 'x 0.8s',
      animationName: keyframes(fadeInLeft, 'fadeInLeft')
    },
    fadeInLeft2: {
      animation: 'x 0.8s',
      animationName: keyframes(fadeInLeft, 'fadeInLeft'),
      animationDelay: '0.1s',
      animationFillMode: 'forwards',
      opacity: 0
    },
    fadeIn: {
      animation: 'x 1s',
      animationName: keyframes(fadeIn, 'fadeIn'),
      animationDelay: '0.7s',
      animationFillMode: 'forwards',
      opacity: 0
    },
    fadeIn2: {
      animation: 'x 1s',
      animationName: keyframes(fadeIn, 'fadeIn'),
      animationDelay: '0.8s',
      animationFillMode: 'forwards',
      opacity: 0
    },
    fadeIn3: {
      animation: 'x 1s',
      animationName: keyframes(fadeIn, 'fadeIn'),
      animationDelay: '0.9s',
      animationFillMode: 'forwards',
      opacity: 0
    },
    fadeIn4: {
      animation: 'x 1s',
      animationName: keyframes(fadeIn, 'fadeIn'),
      animationDelay: '1s',
      animationFillMode: 'forwards',
      opacity: 0
    },
    fadeIn5: {
      animation: 'x 1s',
      animationName: keyframes(fadeIn, 'fadeIn'),
      animationDelay: '1.1s',
      animationFillMode: 'forwards',
      opacity: 0
    }
  }

  const ogLocales = {
    sr: 'sr_RS',
    de: 'de_DE',
    en: 'en_US',
    es: 'es_ES',
    fr: 'fr_FR',
    pt: 'pt_BR',
  };

  return (
    <div>
      <Helmet>
        {/* --- TITLE: Ubaceno "Free" i "Career Guide" za bolji CTR --- */}
        {/* <title>{t("Is Coding For You? Free Online Potential Test & Career Guide")}</title> */}
        <title>{t("Is Coding For You? Take the Quiz")}</title>

        <link rel="canonical" href={lng !== "en" ? `https://iscodingforyou.com/${lng}/` : `https://iscodingforyou.com/`} />
        
        {/* --- DESCRIPTION: Fokus na "15 minuta", "Instant Results" i "Free" --- */}
        <meta name="description" content={t("Take our Coding Potential Quiz to answer the question: Is Coding for Me? Get personalized results and learning recommendations.")}/>

        {/* --- KEYWORDS: Dodate kljucne reci --- */}
        <meta name="keywords" content={t("is coding for me, coding potential test, programming career test, learn to code, developer assessment, coding quiz, it career path")} />

        <meta charSet="utf-8" />

        <link rel="alternate" hreflang="en" href="https://iscodingforyou.com/" />
        <link rel="alternate" hreflang="es" href="https://iscodingforyou.com/es/" />
        <link rel="alternate" hreflang="de" href="https://iscodingforyou.com/de/" />
        <link rel="alternate" hreflang="fr" href="https://iscodingforyou.com/fr/" />
        <link rel="alternate" hreflang="it" href="https://iscodingforyou.com/it/" />
        <link rel="alternate" hreflang="pl" href="https://iscodingforyou.com/pl/" />
        <link rel="alternate" hreflang="tr" href="https://iscodingforyou.com/tr/" />
        <link rel="alternate" hreflang="pt-BR" href="https://iscodingforyou.com/pt/" />
        <link rel="alternate" hreflang="sr" href="https://iscodingforyou.com/sr/" />
        <link rel="alternate" hreflang="x-default" href="https://iscodingforyou.com/" />
        
        {/* --- OPEN GRAPH (Facebook/LinkedIn) --- */}
        <meta property="og:title" key="og:title" content={t("Is Coding For You? Take the Quiz")} />
        <meta property="og:site_name" key="og:site_name" content="Is Coding For You" />
        <meta property="og:url" key="og:url" content={lng !== "en" ? `https://iscodingforyou.com/${lng}/` : `https://iscodingforyou.com/`} />
        <meta property="og:type" key="og:type" content="website" />
        <meta property="og:description" key="og:description" content={t("Take our Coding Potential Quiz to answer the question: Is Coding for Me? Get personalized results and learning recommendations.")} />
        <meta property="og:image" key="og:image" content="https://iscodingforyou.com/about-image.webp" />
        {/* Dinamicki locale ako imas prevode (sr, de, en) */}
        <meta property="og:locale" key="og:locale" content={ogLocales[lng] || 'en_US'}   />
        <meta property="og:locale:alternate" content="sr_RS" />
        <meta property="og:locale:alternate" content="de_DE" />
        <meta property="og:locale:alternate" content="en_US" />
        <meta property="og:locale:alternate" content="es_ES" />
        <meta property="og:locale:alternate" content="fr_FR" />
        <meta property="og:locale:alternate" content="pt_BR" />

        {/* --- TWITTER CARD --- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="https://iscodingforyou.com/" />
        <meta name="twitter:title" content={t("Is Coding For You? Take the Quiz")} />
        <meta name="twitter:image" content="https://iscodingforyou.com/about-image.webp"/>
        <meta name="twitter:description" content={t("Take our Coding Potential Quiz to answer the question: Is Coding for Me? Get personalized results and learning recommendations.")} />
      </Helmet>
      <BasicModal
        handleSubmit={handleSubmit}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
      />
     <div className="content">
        <div className="settings">
          <div className="settings__select">
            {error && <ErrorMessage>{t("Something went wrong. Our team is working to solve it.")}</ErrorMessage>}
            <StyleRoot>
              {/* <h1 className={"home-title-"+i18n.language} style={styles.fadeInLeft1}>
                <span>{t("Is coding for you?")}</span>{' '}
                <span className="title-coding">{t("Online Test")}</span>
                <span className="free-badge">{t("FREE")}</span>
              </h1> */}
              {/* <h1 className={"home-title-"+i18n.language} style={styles.fadeInLeft1}>
                <span>{t("Is coding for you?")}</span>
                <br />
                <div className="title-badge-wrapper">
                    <span className="title-coding">{t("Online Test")}</span>
                    <span className="free-badge">{t("FREE")}</span>
                </div>
              </h1> */}
              <h1 className={"home-title-"+i18n.language} style={styles.fadeInLeft1}>
                {/* PROMENA 1: Menjamo 'you' u 'me' da se slaže sa Title-om i onim što ljudi kucaju */}
                <span>{t("Is coding for you?")}</span>
                <br />
                <div className="title-badge-wrapper">
                    {/* PROMENA 2: Menjamo 'Test' u 'Quiz' jer 'Quiz' donosi bolji CTR u Google konzoli */}
                    <span className="title-coding">{t("Take the Quiz")}</span>{' '}
                </div>
              </h1>
              
              <h2 className="home-title-2" style={styles.fadeInLeft2}>
                <span>{t("Test your coding potential, no experience required.")}</span>
              </h2>
              
              <p className="home-title-3" style={styles.fadeIn}>
                {t("Discover your coding potential by taking this test. Your first step into the coding world awaits.")}
              </p>

              {/* --- NOVO: Umesto liste, sada su ovde KARTICE --- */}
              <div className="hero-features-grid" style={styles.fadeIn2}>
                 <div className="hero-feature-card">
                    <span className="feature-icon">🧩</span>
                    <div className="feature-text">
                        <h3>{t("Problem-solving")}</h3>
                        <p>{t("Timed logical tasks")}</p>
                    </div>
                 </div>
                 <div className="hero-feature-card">
                    <span className="feature-icon">🧠</span>
                    <div className="feature-text">
                        <h3>{t("Personality")}</h3>
                        <p>{t("Unlock your traits")}</p>
                    </div>
                 </div>
                 <div className="hero-feature-card">
                    <span className="feature-icon">🇬🇧</span>
                    <div className="feature-text">
                        <h3>{t("English")}</h3>
                        <p>{t("Check language level")}</p>
                    </div>
                 </div>
              </div>
              {/* ----------------------------------------------- */}

              <div style={styles.fadeInUp}>
                <div className="start-test-wrap">
                  <Button
                    className={classes.button}
                    variant="contained"
                    size="large"
                    onClick={handleOpenModal}
                  >
                    {t("Start Quiz")} {String.fromCodePoint(0x2192)}
                  </Button>
                </div>
                {/* Mali dodatak ispod dugmeta za konverziju */}
                {/* <p className="hero-note" style={{textAlign: 'center', marginTop: '10px', color: '#666', fontSize: '14px'}}>
                   ⏱️ {t("Takes only 5 minutes")}
                </p> */}
              </div>
            </StyleRoot>
          </div>
        </div>
        <div className="banner">
          <StyleRoot>
            <img src="/about-image.webp" className="banner-image app-image" style={styles.fadeInRight} alt={t("Is coding for me?")} width="686" height="498.05"/>
          </StyleRoot>
        </div>
      </div>
      {/* --- NOVA ZASEBNA SEKCIJA ZA POPUST --- */}
      {/* <div className="discount-section-wrapper">
        <div className="discount-offer-container">
            <div className={"discount-badge discount-badge-"+i18n.language}>🎁 {t("Bonus Reward")}</div>
            <p className="discount-text">
              {t("Perform well on the test and unlock up to")} <span className="discount-highlight">{t("50% OFF")}</span> {t("on a recommended coding course!")}
            </p>
        </div>
      </div> */}
      {/* --------------------------------------- */}
      {/* <div className="home-section-2-1">
        <div className="content-2-1" >
          <p className="home-trusted">{t("Across more than {{firstParam}} countries, over {{secondParam}} tests were successfully conducted this month.", {"firstParam":"50", "secondParam": "1000"})}</p>
        </div>
      </div> */}
      {/* SOCIAL PROOF SEKCIJA */}
      <div className="home-section-trust" style={{ 
          backgroundColor: "#e8ebfa", /* Blago siva pozadina da ga odvoji od bele Hero sekcije */
          padding: "40px 20px", 
          textAlign: "center", 
          borderBottom: "1px solid #eaeaea",
          borderTop: "1px solid #eaeaea"
      }}>
        <div className="trust-content" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          
          {/* Zvezdice i Glavni Naslov */}
          <div style={{ marginBottom: "30px" }}>
            <div style={{ color: "#F49F1C", fontSize: "28px", letterSpacing: "5px", marginBottom: "10px" }}>
              ★★★★★
            </div>
            <p style={{ fontSize: "20px", fontWeight: "600", color: "#333", margin: "0" }}>
              {t("Trusted by over 50,000 future developers worldwide")}
            </p>
          </div>

          {/* Tri Statistike u redu */}
          <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              gap: "60px", 
              flexWrap: "wrap", /* Da bi lepo palo u nov red na mobilnom telefonu */
              marginTop: "20px" 
          }}>
             
             {/* Statistika 1: Ocena */}
             <div className="trust-stat" style={{ textAlign: "center" }}>
                <h4 style={{ fontSize: "32px", color: "#030E4F", margin: "0 0 5px 0", fontWeight: "900" }}>4.9/5</h4>
                <p style={{ color: "#666", margin: "0", fontSize: "13px", textTransform: "uppercase", letterSpacing: "1px", fontWeight: "bold" }}>
                  {t("Average Rating")}
                </p>
             </div>

             {/* Statistika 2: Testovi */}
             <div className="trust-stat" style={{ textAlign: "center" }}>
                <h4 style={{ fontSize: "32px", color: "#030E4F", margin: "0 0 5px 0", fontWeight: "900" }}>100k+</h4>
                <p style={{ color: "#666", margin: "0", fontSize: "13px", textTransform: "uppercase", letterSpacing: "1px", fontWeight: "bold" }}>
                  {t("Tests Completed")}
                </p>
             </div>

             {/* Statistika 3: Države */}
             <div className="trust-stat" style={{ textAlign: "center" }}>
                <h4 style={{ fontSize: "32px", color: "#030E4F", margin: "0 0 5px 0", fontWeight: "900" }}>50+</h4>
                <p style={{ color: "#666", margin: "0", fontSize: "13px", textTransform: "uppercase", letterSpacing: "1px", fontWeight: "bold" }}>
                  {t("Countries Reached")}
                </p>
             </div>

          </div>
        </div>
      </div>    

      
      <div className="home-section-2">
        <div className="content-2-new" >
          <h2 className="home-title-section-2"><span className="title-coding-why">{t("Why")}</span> {t("Our Test?")}</h2>
          <div className="home-why-section">
            <Card sx={{ maxWidth: 345 }} className="home-why-card">
              <div className="why-image">
                <img src="/home-why-51.svg" className="banner-image app-image" alt={t("Unlock Your Coding Potential")} width="120" height="120"/>
              </div>
              <CardContent>
                  <h3 className="why-card-title">
                    {t("Unlock Your Coding Potential")}
                  </h3>
                  <p className="why-card-description">
                    {t("Unveil your coding potential and explore promising opportunities. Our test helps you make right decisions about learning to code or pursuing a coding career.")}
                  </p>
              </CardContent>
            </Card>
            <Card sx={{ maxWidth: 345 }} className="home-why-card">
              <div className="why-image">
                <img src="/home-why-3.svg" className="banner-image app-image" alt={t("Discover Your Ideal IT Position")} width="120" height="120"/>
              </div>
              <CardContent>
                <h3 className="why-card-title">
                  {t("Discover Your Ideal IT Position")}
                </h3>
                <p className="why-card-description">
                  {t("Embark on a personalized IT journey with our assessment. Discover your forte—whether it's full stack, frontend, backend, or QA testing. Uncover the perfect IT position tailored just for you.")}
                </p>
              </CardContent>
            </Card>
            <Card sx={{ maxWidth: 345 }} className="home-why-card">
              <div className="why-image">
                <img src="/home-why-2.svg" className="banner-image app-image" alt={t("Get personalized learning guidelines")} width="120" height="120"/>
              </div>
              <CardContent>
                  <h3 className="why-card-title">
                    {t("Get personalized learning guidelines")}
                  </h3>
                <p className="why-card-description">
                  {t("Unlock insights tailored to enhance your coding skills with our assessment. Receive a personalized report and guidelines to navigate your unique learning journey.")}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      <div className="section-3-people-1">
        <div className="section-3-people">
          <div className="ban-banner">
            <div className="ban-container">
              <div className="ban-container-head">
                <div className="ban-image-container">
                  <img src="/ban.jpeg" className="ban-image" alt={t("Head of Engineering & Business Development")} width="80" height="80"/>
                </div>
                <div>
                  <p className="ban-head-desc ban-head-desc-name">Ben Burmudzija</p>
                  <p className="ban-head-desc">{t("Head of Engineering & Business Development")}</p>
                </div>
              </div>
              <div>
                <p className="ban-content">
                  "{t("Coding is like singing. Anyone can sing, but not everyone is good at it. The same goes for coding. Try our test and assess your coding potential.")}"
                </p>
              </div>
              <Button 
                variant="outlined"
                className="ban-button"
                onClick={handleOpenModal}>
                  {t("Take the Test")}
              </Button>
            </div>
          </div>
          <div className="ban-banner-empty">

          </div>
        </div>
      </div>
      <div className="home-section-3-1">
        <div className="content-3-1">
         <div className="banner-3-1">
            <img src="/result4Blur.webp" className="banner-image app-image" style={styles.fadeInRight} alt={t("Take the Test")} width="348" height="457.63"/>
          </div>
          <div className="settings-3-1">
            <div className="settings-3-1-text modern-text-box">
              <h2 className="home-title-section-3-1">
                {t("Have you ever wondered")}{", "}
                <br/>
                <span className="highlight-marker">
                  {"\""}{t("Is coding for me?")}{"\""}
                </span>
              </h2>
              <p className="home-p-section-3-1">
                {t("If you've been pondering this question, you're not alone. Many individuals, at some point, consider the exciting world of coding as a potential path.")}
              </p>
              
              {/* --- NOVO: Bullet points da razbiju tekst --- */}
              <div className="text-features">
                 <div className="text-feature-item">
                    <span className="check-icon">✓</span>
                    <span>{t("Get personalized insights")}</span>
                 </div>
                 <div className="text-feature-item">
                    <span className="check-icon">✓</span>
                    <span>{t("Discover your potential")}</span>
                 </div>
                 <div className="text-feature-item">
                    <span className="check-icon">✓</span>
                    <span>{t("Save time on decision making")}</span>
                 </div>
              </div>
              {/* ------------------------------------------- */}

            </div>
          </div>
        </div>
      </div>
      <div className="home-section-3">
        <div className="content-3">
          <div className="settings-3">
            <div className="settings-3-text">
              <h2 className="home-title-section-2 home-title-section-3">
                  <span className="title-coding-why">{t("What")}</span>{" "}{t("is this Test?")}
              </h2>
              
              {/* Uvodni tekst - Lead Paragraph */}
              <p className="test-lead-text">
                {t("This is a test aimed at helping beginners determine if coding is the right fit. It's designed in the form of a quiz to provide personalized results that guide your path forward.")}
              </p>

              {/* --- NOVO: Info Grid umesto liste --- */}
              <div className="test-info-grid">
                  {/* Kartica 1: Pitanja */}
                  <div className="test-info-card">
                      <div className="info-card-icon">📝</div>
                      <div className="info-card-content">
                          <h4>{t("{{firstParam}} Questions", {"firstParam":"35"})}</h4>
                          <p>{t("Designed by experts")}</p>
                      </div>
                  </div>

                  {/* Kartica 2: Izveštaj */}
                  <div className="test-info-card">
                      <div className="info-card-icon">📊</div>
                      <div className="info-card-content">
                          <h4>{t("Detailed Report")}</h4>
                          <p>{t("Personalized feedback")}</p>
                      </div>
                  </div>

                  {/* Kartica 3: Rezultat */}
                  <div className="test-info-card">
                      <div className="info-card-icon">⚡</div>
                      <div className="info-card-content">
                          <h4>{t("Immediate Results")}</h4>
                          <p>{t("Sent to your email")}</p>
                      </div>
                  </div>

                  {/* Kartica 4: Svrha */}
                  <div className="test-info-card">
                      <div className="info-card-icon">🎯</div>
                      <div className="info-card-content">
                          <h4>{t("Career Guidance")}</h4>
                          <p>{t("Find your path")}</p>
                      </div>
                  </div>
              </div>
              {/* ------------------------------------ */}
            </div>

            <div className="ready-cta-wrapper">
                <p className="home-ready-2">{t("Are you ready?")}</p>
                <Button
                className={classes.button2}
                variant="contained"
                size="large"
                onClick={handleOpenModal}
                >
                {t("Start Quiz")} {String.fromCodePoint(0x2192)}
                </Button>
            </div>
          </div>
          
          <div className="banner-3">
            <img src="/home-section-3.png" className="banner-image app-image" alt={t("Is coding for you?")} width="348" height="457.63"/>
          </div>
        </div>
      </div>
      <div className="home-section-5">
        <div className="content-2-new content-5">
          <h2 className="home-section-5-title">{t("Frequently Asked Questions")}</h2>
          <Accordion>
            <AccordionSummary
              expandIcon={String.fromCodePoint(8964)}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <h3 className="faq-title">{t("Is coding the right fit for me?")}</h3>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {t("If you feel a curiosity for problem-solving, analyzing information, and embracing challenges, coding might be the perfect fit. Our test helps you better understand your inclination towards coding.")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={String.fromCodePoint(8964)}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <h3 className="faq-title">{t("What if I have no prior programming experience?")}</h3>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {t("Our test is designed for absolute beginners. Regardless of your past experience, it provides insights into your coding potential.")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={String.fromCodePoint(8964)}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <h3 className="faq-title">{t("How long does the testing take, and how do I receive the results?")}</h3>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {t("Testing usually takes around 10-15 minutes. Upon completion, you'll instantly receive a detailed report assessing your coding predisposition and offering personalized recommendations.")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={String.fromCodePoint(8964)}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <h3 className="faq-title">{t("Can coding be a career path for someone without a technical background?")}</h3>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {t("Absolutely! Coding welcomes diverse backgrounds. Many successful developers started without a technical foundation. Our test guides you on your coding journey, regardless of your initial background.")}
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={String.fromCodePoint(8964)}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <h3 className="faq-title">{t("Is programming only for young individuals, or can anyone start learning at any age?")}</h3>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {t("Programming knows no age limits! Whether you're a teenager or considering a career change later in life, our online programming test evaluates your potential, making it accessible for learners of all ages.")}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
      <div className="result-social-home">
        <h2 className="social-title">{t("Help us spread the word and let your friends take the test too")}</h2>
        <div className="social-icons">
          <a href="whatsapp://send?text=Is Coding For Me. Online Quiz https://iscodingforyou.com">
            <img src="/social-wa.png" className="social-icon" alt="wathsapp" width="50" height="50"/>
          </a>
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.iscodingforyou.com" target="_blank">
            <img src="/social-fb.png" className="social-icon" alt="facebook" width="50" height="50"/>
          </a>
          <a href="https://twitter.com/intent/tweet?url=https://www.iscodingforyou.com&text=Is Coding For Me. Online Quiz" target="_blank">
            <img src="/social-tw.png" className="social-icon" alt="tweeter" width="50" height="50"/>
          </a>
          <a href="https://www.linkedin.com/shareArticle?url=https://www.iscodingforyou.com&title=Is Coding For Me. Online Quiz" target="_blank">
            <img src="/social-ln.png" className="social-icon" alt="linkedin" width="50" height="50"/>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
